var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpshiftIconMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "100%",
    viewBox: "0 0 260 248",
    enableBackground: "new 0 0 260 248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#486CFE",
    opacity: 1,
    stroke: "none",
    d: " M44.815807,101.918373 C63.603661,83.056450 82.393349,64.196358 101.178589,45.331833 C110.658646,35.811771 120.130623,26.283678 129.456680,16.909550 C163.793930,51.165863 197.809097,85.100853 231.583191,118.795334 C221.802094,128.758316 211.954697,138.788849 201.744247,149.189163 C177.907074,125.207390 154.024292,101.179741 128.816666,75.819214 C113.072914,92.202652 97.869949,108.023323 82.222473,123.660873 C79.889626,121.516373 77.171005,119.863052 76.302872,117.523178 C74.917641,113.789551 72.210541,114.541489 71.121498,116.158134 C67.949402,120.867050 63.013409,119.896034 58.770416,120.771332 C50.675682,122.441200 47.199280,119.219627 46.900082,111.169647 C46.784664,108.064354 45.543869,105.000893 44.815807,101.918373 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#617AFE",
    opacity: 1,
    stroke: "none",
    d: "M 131.197 169.733 C 128.218 172.255 83.378 162.858 80.073 162.455 C 95.599 147.353 114.909 128.751 130.482 113.603 C 154.385 136.876 178.882 160.728 203.283 184.485 C 192.663 195.045 183.374 204.282 173.73 213.871 C 159.846 199.463 145.595 184.674 131.197 169.733 Z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    stroke: "none",
    d: "M 83.56 159.096 C 87.162 159.359 151.181 163.561 120.447 175.51 C 116.213 177.156 113.651 175.61 117.695 173.707 C 119.18 174.758 129.354 168.623 131.329 169.769 C 119.281 181.982 98.267 201.436 85.255 214.198 C 76.342 204.712 67.187 194.97 57.411 184.565 C 65.544 176.597 74.403 167.916 83.56 159.096 Z",
    style: {
      fill: "rgb(97, 122, 254)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    stroke: "none",
    d: "M 44.991 101.725 C 46.022 104.664 47.032 107.82 47.147 110.925 C 47.446 118.975 50.923 122.197 59.017 120.527 C 63.26 119.652 67.256 120.281 70.428 115.572 C 71.518 113.955 75.165 113.545 76.55 117.279 C 77.418 119.619 80.222 121.272 82.251 123.563 C 73.918 132.051 65.359 140.208 57.173 148.087 C 47.598 138.92 37.665 129.411 27.183 119.376 C 33.208 113.302 39.064 107.539 44.991 101.725 Z",
    style: {
      fill: "rgb(72, 108, 254)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpshiftIconMini);
export default __webpack_public_path__ + "static/media/upshift_icon_mini.1fb87e10c322be9c3ff07b58586ac47f.svg";
export { ForwardRef as ReactComponent };